module.exports = __webpack_public_path__ + "static/img/slogn-es.706b7ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn/slogn-es.png
// module id = CPlP
// module chunks = 1